import { render, staticRenderFns } from "./Game2-8.vue?vue&type=template&id=dbaa044c&scoped=true&"
import script from "./Game2-8.vue?vue&type=script&lang=js&"
export * from "./Game2-8.vue?vue&type=script&lang=js&"
import style0 from "./Game2-8.vue?vue&type=style&index=0&id=dbaa044c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbaa044c",
  null
  
)

export default component.exports